<template>
  <img src="https://ct.capterra.com/capterra_tracker.gif?vid=2175762&vkey=0d82c43c431b2e20dbd25978783d0c39">
</template>

<script>
export default {
  name: 'CapterraTrackerPixel'
}
</script>

<style scoped>
</style>
